var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackmain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CFF3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6CD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#a)",
    fill: "none",
    strokeLinecap: "round",
    strokeDashoffset: 25
  }, /*#__PURE__*/React.createElement("circle", {
    r: 357.5,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "11 13",
    transform: "rotate(272 400 400)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    r: 351,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "40 35",
    transform: "rotate(272 400 400)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("circle", {
    r: 344.5,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "21 37",
    transform: "rotate(20 400 400)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("circle", {
    r: 338,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "43 31",
    transform: "rotate(353 400 400)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 331.5,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "22 19",
    transform: "rotate(70 400 400)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    r: 325,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "48 22",
    transform: "rotate(104 400 400)",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("circle", {
    r: 318.5,
    cx: 400,
    cy: 400,
    strokeWidth: 5,
    strokeDasharray: "15 11",
    transform: "rotate(66 400 400)",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    r: 312,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "52 44",
    transform: "rotate(11 400 400)",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("circle", {
    r: 305.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "52 54",
    transform: "rotate(279 400 400)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("circle", {
    r: 299,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "26 25",
    transform: "rotate(47 400 400)",
    opacity: 0.21
  }), /*#__PURE__*/React.createElement("circle", {
    r: 292.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "33 20",
    transform: "rotate(187 400 400)",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("circle", {
    r: 286,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "18 16",
    transform: "rotate(29 400 400)",
    opacity: 0.24
  }), /*#__PURE__*/React.createElement("circle", {
    r: 279.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "43 14",
    transform: "rotate(321 400 400)",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("circle", {
    r: 273,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "35 50",
    transform: "rotate(358 400 400)",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("circle", {
    r: 266.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "27 32",
    transform: "rotate(267 400 400)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 260,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "38 15",
    transform: "rotate(189 400 400)",
    opacity: 0.31
  }), /*#__PURE__*/React.createElement("circle", {
    r: 253.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "42 35",
    transform: "rotate(191 400 400)",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    r: 247,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "31 34",
    transform: "rotate(323 400 400)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    r: 240.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "51 19",
    transform: "rotate(292 400 400)",
    opacity: 0.37
  }), /*#__PURE__*/React.createElement("circle", {
    r: 234,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "11 12",
    transform: "rotate(260 400 400)",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    r: 227.5,
    cx: 400,
    cy: 400,
    strokeWidth: 4,
    strokeDasharray: "15 31",
    transform: "rotate(306 400 400)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 221,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "21 55",
    transform: "rotate(323 400 400)",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    r: 214.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "32 54",
    transform: "rotate(202 400 400)",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("circle", {
    r: 208,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "50 16",
    transform: "rotate(249 400 400)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("circle", {
    r: 201.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "55 32",
    transform: "rotate(191 400 400)",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("circle", {
    r: 195,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "12 35",
    transform: "rotate(329 400 400)",
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    r: 188.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "28 50",
    transform: "rotate(119 400 400)",
    opacity: 0.51
  }), /*#__PURE__*/React.createElement("circle", {
    r: 182,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "52 45",
    transform: "rotate(132 400 400)",
    opacity: 0.53
  }), /*#__PURE__*/React.createElement("circle", {
    r: 175.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "53 35",
    transform: "rotate(165 400 400)",
    opacity: 0.54
  }), /*#__PURE__*/React.createElement("circle", {
    r: 169,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "20 22",
    transform: "rotate(268 400 400)",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("circle", {
    r: 162.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "32 33",
    transform: "rotate(109 400 400)",
    opacity: 0.58
  }), /*#__PURE__*/React.createElement("circle", {
    r: 156,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "18 48",
    transform: "rotate(232 400 400)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    r: 149.5,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "29 11",
    transform: "rotate(169 400 400)",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("circle", {
    r: 143,
    cx: 400,
    cy: 400,
    strokeWidth: 3,
    strokeDasharray: "19 18",
    transform: "rotate(80 400 400)",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("circle", {
    r: 136.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "21 40",
    transform: "rotate(147 400 400)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    r: 130,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "30 47",
    transform: "rotate(266 400 400)",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("circle", {
    r: 123.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "19 43",
    transform: "rotate(60 400 400)",
    opacity: 0.68
  }), /*#__PURE__*/React.createElement("circle", {
    r: 117,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "14 42",
    transform: "rotate(19 400 400)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 110.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "34 36",
    transform: "rotate(62 400 400)",
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("circle", {
    r: 104,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "32 35",
    transform: "rotate(307 400 400)",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("circle", {
    r: 97.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "34 34",
    transform: "rotate(152 400 400)",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    r: 91,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "41 24",
    transform: "rotate(272 400 400)",
    opacity: 0.77
  }), /*#__PURE__*/React.createElement("circle", {
    r: 84.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "45 38",
    transform: "rotate(226 400 400)",
    opacity: 0.79
  }), /*#__PURE__*/React.createElement("circle", {
    r: 78,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "19 37",
    transform: "rotate(99 400 400)",
    opacity: 0.81
  }), /*#__PURE__*/React.createElement("circle", {
    r: 71.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "29 12",
    transform: "rotate(103 400 400)",
    opacity: 0.82
  }), /*#__PURE__*/React.createElement("circle", {
    r: 65,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "19 39",
    transform: "rotate(352 400 400)",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    r: 58.5,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "51 39",
    transform: "rotate(248 400 400)",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("circle", {
    r: 52,
    cx: 400,
    cy: 400,
    strokeWidth: 2,
    strokeDasharray: "46 25",
    transform: "rotate(36 400 400)",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    r: 45.5,
    cx: 400,
    cy: 400,
    strokeDasharray: "45 30",
    transform: "rotate(124 400 400)",
    opacity: 0.89
  }), /*#__PURE__*/React.createElement("circle", {
    r: 39,
    cx: 400,
    cy: 400,
    strokeDasharray: "19 35",
    transform: "rotate(312 400 400)",
    opacity: 0.91
  }), /*#__PURE__*/React.createElement("circle", {
    r: 32.5,
    cx: 400,
    cy: 400,
    strokeDasharray: "41 19",
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("circle", {
    r: 26,
    cx: 400,
    cy: 400,
    strokeDasharray: "32 49",
    transform: "rotate(275 400 400)",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("circle", {
    r: 19.5,
    cx: 400,
    cy: 400,
    strokeDasharray: "38 16",
    transform: "rotate(154 400 400)",
    opacity: 0.96
  }), /*#__PURE__*/React.createElement("circle", {
    r: 13,
    cx: 400,
    cy: 400,
    strokeDasharray: "20 16",
    transform: "rotate(103 400 400)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.5,
    cx: 400,
    cy: 400,
    strokeDasharray: "34 44",
    transform: "rotate(296 400 400)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackmain);
export default __webpack_public_path__ + "static/media/backmain.378e1df36d3e3544818dc46c23d3bf3d.svg";
export { ForwardRef as ReactComponent };